import API_GATEWAY from "@/services/config/main-axios";

const gatewayService = {
  getPosGateways(filters) {
    return API_GATEWAY.get("user-profile/admin/gateway/pos/index", {
      params: filters
    });
  },

  activePos(model) {
    return API_GATEWAY.post("user-profile/admin/gateway/pos/active", model);
  },

  changeStatus(model) {
    return API_GATEWAY.post("user-profile/admin/gateway/changeStatus", model);
  },

  getGatewayData(id) {
    return API_GATEWAY.get(`user-profile/admin/gatewayData/${id}`);
  },

  reSendGatewayData(gatewayId) {
    return API_GATEWAY.get(`user-profile/admin/resend/gateway/${gatewayId}`);
  }
};

export default gatewayService;
